'use strict';

module.exports = typeof window === 'undefined' ? global : window;



// WEBPACK FOOTER //
// ./assets/js/checkout/helpers/checkout-window-check.es.js